/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ApiKeyEntityType {
    CalendarConnection = 1,
    ImportConfiguration = 2,
    OrderIssue = 3,
    Parquet = 4,
    SynchronizeLocation = 5,
    OrgaMcp = 6,
    DataMcp = 7,
    TechMcp = 8,
}
